import { createContext, useContext } from 'react';
var titleSetter = function (data) {
    if (data.title) {
        document.title = data.title;
    }
};
var defaults = {
    setPageTitle: titleSetter
};
var context = createContext(defaults);
export var PageTitleProvider = context.Provider;
export var usePageTitle = function () { return useContext(context); };
export var usePageTitleSetter = function () {
    var setPageTitle = titleSetter;
    return { setPageTitle: setPageTitle };
};
//# sourceMappingURL=page-title-context.js.map